import React,{useContext,useEffect, useState, useRef} from 'react';
import { LocaleContext } from '../../../components/LocaleContext';
import { DatabaseContext } from '../../../redux/DatabaseStore';
import { useFormik, FieldArray } from 'formik';
import { postRequest } from '../../../api/ApiController';
import { SaveIcon, AddIcon, EditIcon, CopyIcon, DeleteIcon, StepBackIcon, StepForwardIcon, PrintIcon, SearchIcon, ExportIcon, VerticalLineIcon, BackToFirstIcon, BackIcon, ForwardIcon, ForwardToLastIcon, FavoriteIcon, PriceIcon, SaveAndCloseIcon} from "../../svg/svgIcons";
import UtilContext from '../../../components/UtilContext';
import { MultiSelect } from 'primereact/multiselect';
import { ColorPicker } from 'primereact/colorpicker';
import { Checkbox } from 'primereact/checkbox';
import { Calendar } from 'primereact/calendar';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import AuthContext from '../../../components/AuthContext';
import { createArrayNavigateHandlers } from '../../../utils/arrayNavigate';
import {
    appendChecklistTemplateWriteFormData,
    canonicalChecklistTemplateToFormValues,
    dispatchUpsertChecklistTemplate,
    EMPTY_CHECKLIST_TEMPLATE_SENDING_DATA,
    extractChecklistTemplateWritePayload,
    formikErrorsFromLaravel,
    interpretChecklistTemplateWriteResponse,
    isChecklistTemplateWriteOk,
    validateChecklistTemplateFormValues,
} from '../../../utils/checklistTemplatesLookup';

export default function ChecklistTemplateAdd({checklist_template=null,type="add"}) {
  const { t } = useContext(LocaleContext);

    const [state,dispatch] = useContext(DatabaseContext);
    const {openFavoriteDialog,toast,setFastView,setVisible,setDialogText,getSlovakColorName}= useContext(UtilContext);
    const {user} = useContext(AuthContext);

    const [formChecklistTemplate,setFormChecklistTemplate] = useState(checklist_template);
    const [formType, setFormType] = useState(type);

    const [recipients,setRecipients] = useState(state.users);

    const [stepBackIcon,setStepBackIcon] = useState(true);
    const [scrollIcons,setScrollIcons] = useState(true);

    const submitRef = useRef(null);
    const componentRef = useRef(null);
    const closeAfterRef = useRef(false);

    useEffect(() => {
        if(checklist_template!=null){
            const departments = extractDepartmentsFromRecipients(checklist_template?.users || []);
            setRecipients(state.users?.filter(user => departments.map(department => department.id).includes(parseInt(user?.employee?.department_id))));
            //console.log(checklist_template);
        }
    }, [checklist_template]);

    useEffect(() => {
        if(formChecklistTemplate!=null){
            //console.log(formChecklistTemplate);
        }
    }, [formChecklistTemplate]);

    useEffect(() => {
        // Update the document title using the browser API
        if(formType=="edit"){
            setScrollIcons(false);
        }
    },[formType]);

    const daysOfWeekOptions = [
        { label: 'Pondelok', value: '1' },
        { label: 'Utorok', value: '2' },
        { label: 'Streda', value: '3' },
        { label: t('Common.Day.Thursday'), value: '4' },
        { label: 'Piatok', value: '5' },
    ];

    const specialMonthlyOptions = [
        { label: t('ChecklistTemplate.SpecialDay.first_monday'), value: 'first_monday' },
        { label: t('ChecklistTemplate.SpecialDay.first_tuesday'), value: 'first_tuesday' },
        { label: t('ChecklistTemplate.SpecialDay.first_wednesday'), value: 'first_wednesday' },
        { label: t('ChecklistTemplate.SpecialDay.first_thursday'), value: 'first_thursday' },
        { label: t('ChecklistTemplate.SpecialDay.first_friday'), value: 'first_friday' },
        { label: t('ChecklistTemplate.SpecialDay.last_monday'), value: 'last_monday' },
        { label: t('ChecklistTemplate.SpecialDay.last_tuesday'), value: 'last_tuesday' },
        { label: t('ChecklistTemplate.SpecialDay.last_wednesday'), value: 'last_wednesday' },
        { label: t('ChecklistTemplate.SpecialDay.last_thursday'), value: 'last_thursday' },
        { label: t('ChecklistTemplate.SpecialDay.last_friday'), value: 'last_friday' },
    ];

    const months = [
        { label: t('Common.Month.January'), value: '1' },
        { label: t('Common.Month.February'), value: '2' },
        { label: 'Marec', value: '3' },
        { label: t('Common.Month.April'), value: '4' },
        { label: t('Common.Month.May'), value: '5' },
        { label: t('Common.Month.June'), value: '6' },
        { label: t('Common.Month.July'), value: '7' },
        { label: 'August', value: '8' },
        { label: 'September', value: '9' },
        { label: t('Common.Month.October'), value: '10' },
        { label: 'November', value: '11' },
        { label: 'December', value: '12' },
    ];

    function filterRecipients(departments){
        formik.setFieldValue("recipientDepartments",departments.map((department) => ({name:department.name,id:department.id})));
        setRecipients(state.users.filter(user => departments.map(department => department.id).includes(parseInt(user?.employee?.department_id))));
        if(departments.length==0){
            setRecipients(state.users);
            formik.setFieldValue("recipients",[]);
        }
        else{
            formik.setFieldValue("recipients",state.users.filter(user => departments.map(department => department.id).includes(parseInt(user?.employee?.department_id))).map((user) => ({name:user?.employee?.name || user?.username,id:user.id,searchLabel: removeDiacritics(user?.employee?.name || user?.username).toLowerCase()})));
        }
    }

    const extractDepartmentsFromRecipients = (recipients) => {
        const departmentMap = new Map();

        recipients.forEach((user) => {
            const dept = user?.employee?.department;
            if (dept && !departmentMap.has(dept.id)) {
            departmentMap.set(dept.id, {
                id: dept.id,
                name: dept.name,
                searchLabel: removeDiacritics(dept.name).toLowerCase(),
            });
            }
        });

        return Array.from(departmentMap.values());
    };

    const validate = values => validateChecklistTemplateFormValues(values);

    /* form for adding error record */
    const formik = useFormik({
        initialValues: canonicalChecklistTemplateToFormValues(formChecklistTemplate),
        enableReinitialize:true,
        validate,
        onSubmit: values => {
            setDialogText(t('Common.Saving'));
            setVisible(true);
            const closeAfterSave = closeAfterRef.current;
            const formData = appendChecklistTemplateWriteFormData(new FormData(), values);
            const applySuccess = (response, successDetail) => {
                const { row, changed } = extractChecklistTemplateWritePayload(response);
                if (changed === false) {
                    if (closeAfterSave) dispatch({type:'close_tab',id:state.selectedTab});
                    setVisible(false);
                    return;
                }
                if (row) {
                    dispatchUpsertChecklistTemplate(dispatch, row);
                    setFormChecklistTemplate(row);
                    formik.setValues(canonicalChecklistTemplateToFormValues(row));
                }
                if (formType=="add") setFormType("edit");
                if (closeAfterSave) dispatch({type:'close_tab',id:state.selectedTab});
                setVisible(false);
                toast?.current?.show({ severity: 'info', summary: t('Common.Confirmed'), life: 3000, detail: successDetail });
            };
            const applyFailure = (response, reason) => {
                setVisible(false);
                const interpreted = interpretChecklistTemplateWriteResponse(response);
                if (interpreted.kind === 'validation') {
                    formik.setErrors({ ...formik.errors, ...formikErrorsFromLaravel(interpreted.fieldErrors) });
                    toast?.current?.show({
                        severity: 'error',
                        summary: t('Common.Error'),
                        life: 4000,
                        detail: interpreted.message || Object.values(interpreted.fieldErrors)[0] || t('Common.CheckRequiredFields'),
                    });
                    return;
                }
                toast?.current?.show({
                    severity: 'error',
                    summary: t('Common.Error'),
                    life: 4000,
                    detail: interpreted.message || reason?.message || t('Common.Toast.ActionFailedDetail'),
                });
            };
            const request = formType=="add"
                ? postRequest('/api/checklist_templates', formData,true)
                : postRequest(`/api/checklist_templates/update/${formik.values.id}`, formData,true);
            request.then((response) => {
                if (!isChecklistTemplateWriteOk(response)) {
                    applyFailure(response);
                    return;
                }
                applySuccess(response, formType=="add" ? t('Common.Toast.RecordSavedDetail') : t('Common.Toast.RecordUpdatedDetail'));
            }).catch((reason) => {
                applyFailure(null, reason);
            });
        },
    });

      function copyDepartment(){
        dispatch({type:'create_new_tab',name: t('Checklist.NewState'), translationKey: 'Checklist.NewState', legacyLabel: t('Checklist.NewState'),page:'ChecklistTemplateAdd',props:{checklist_template: formik.values,type:'add'},mask:'chck001'})
      }
      function addNewDepartment(){
        dispatch({type:'create_new_tab',name: t('Checklist.NewState'), translationKey: 'Checklist.NewState', legacyLabel: t('Checklist.NewState'),page:'ChecklistTemplateAdd',props:{checklist_template: null,type:'add'},mask:'chck001'})
      }

    const { scrollToFirst, scrollUp, scrollDown, scrollToLast } = createArrayNavigateHandlers(state.checklist_templates, formik.values.id, setFormChecklistTemplate);

    const handleQuestionChange = (index, field, value) => {
        const updated = [...formik.values.questions];

        if(field === 'question'){
            updated[index] = {
                ...updated[index],
                question: value,
            };
        } 
        else{
            let newOptions = {
                ...updated[index].options,
                [field]: value,
            };

            // Ak je odškrtnuté OK/NOK → zruš aj NOK poznámku
            if (field === 'okNok' && !value) {
                newOptions.nokNote = false;
                newOptions.okNote = false;
            }

            // Ak je odškrtnuté NO → zruš aj NO poznámku
            if (field === 'no' && !value) {
                newOptions.noNote = false;
            }

            // Ak je odškrtnuté Meno → zruš aj prioritné oddelenia
            if (field === 'name' && !value) {
                newOptions.priorityDepartments = [];
            }

            updated[index] = {
                ...updated[index],
                options: newOptions,
            };
        }
        formik.setFieldValue('questions', updated);
    };

    const addQuestion = () => {
        const newQuestion = {
        question: '',
        options: {
            okNok: false,
            okNote: false,
            nokNote: false,
            no: false,
            noNote: false,
            photo: false,
            optional_photo: false,
            name: false,
            priorityDepartments: []
        },
        };
        formik.setFieldValue('questions', [...formik.values.questions, newQuestion]);
    };

    const removeQuestion = (index) => {
        const updated = [...formik.values.questions];
        updated.splice(index, 1);
        formik.setFieldValue('questions', updated);
    };

    function removeDiacritics(str) {
        return (str || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }

    const updateSendingData = (newData) => {
        const updated = { ...EMPTY_CHECKLIST_TEMPLATE_SENDING_DATA, ...formik.values.sending_data, ...newData };
        formik.setFieldValue('sending_data', updated);
    };

    const moveQuestion = (index, direction) => {
        const questions = [...formik.values.questions];
        const newIndex = direction === 'up' ? index - 1 : index + 1;
        if (newIndex < 0 || newIndex >= questions.length) return;
        // Swap
        [questions[index], questions[newIndex]] = [questions[newIndex], questions[index]];
        formik.setFieldValue('questions', questions);
    };


    const notifBeforeOptions = [
      { label: "1 hodina pred", value: "1 hours" },
      { label: "2 hodiny pred", value: "2 hours" },
      { label: "4 hodiny pred", value: "4 hours" },
      { label: t('Common.Notify.Hours6Before'), value: "6 hours" },
      { label: t('Common.Notify.Day1Before'), value: "1 days" },
      { label: "2 dni pred", value: "2 days" },
      { label: "3 dni pred", value: "3 days" },
      { label: t('Common.Notify.Days5Before'), value: "5 days" },
      { label: t('Common.Notify.Days7Before'), value: "7 days" },
      { label: t('Common.Notify.Days10Before'), value: "10 days" },
      { label: t('Common.Notify.Days14Before'), value: "14 days" },
      { label: t('Common.Notify.Days30Before'), value: "30 days" },
    ];


return(
<>
<div>
    <div className='w-full h-10 flex flex-row bg-[#333]'>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="save-close"><button type='submit' onClick={() => { closeAfterRef.current = true; submitRef.current.click(); }}><SaveAndCloseIcon/></button></div>
        <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center' data-targetid="save"><button type='submit' onClick={() => { closeAfterRef.current = false; submitRef.current.click(); }}><SaveIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => addNewDepartment()}><AddIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" disabled onClick={() => copyDepartment()}><CopyIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToFirst()} disabled={scrollIcons}><BackToFirstIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollUp()} disabled={scrollIcons}><BackIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollDown()} disabled={scrollIcons}><ForwardIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button className="disabled:opacity-25" onClick={() => scrollToLast()} disabled={scrollIcons}><ForwardToLastIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => openFavoriteDialog(t('Checklist.NewTemplate'),"ChecklistTemplateAdd")}><FavoriteIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><button onClick={() => setFastView("ChecklistTemplateAdd")}><PriceIcon/></button></div>
          <div className='flex flex-col w-10 h-10 px-2 py-1 justify-center'><VerticalLineIcon/></div>
        </div>
<div className="relative flex flex-col justify-left overflow-y-auto h-[calc(100vh-177px)]">
    <div className=" mb-2 ">
    <form onSubmit={formik.handleSubmit}>
      <div className="w-auto p-6 m-4 bg-gray-100">
        <h1 className="text-3xl font-semibold text-left text-zinc-900">{t('Ui.R67.Sablona_checklistu')}</h1>

        {/* Názov checklistu */}
        <div className="mb-4">
          <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.Nazov')}</label>
          <input
            name="name" required
            value={formik.values.name ?? ''}
            onChange={formik.handleChange}
            className="block w-full px-4 py-2 mt-1 border rounded-md"
          />
          {formik.errors.name ? <div className="text-red-600 text-sm mt-1">{formik.errors.name}</div> : null}
        </div>

        {/* Oddelenie */}
        <div className="mb-4">
            <label
                htmlFor="recipientDepartment"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Department')}</label>
            <MultiSelect onChange={(e) => filterRecipients(e.target.value)} value={formik.values.recipientDepartments} 
                options={state.departments.map((department) => 
                    ({name:department.name,id:department.id})
                )} 
                optionLabel="name"
                filter placeholder={t('Common.SelectDepartments')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
        </div>
        <div className="mb-4">
            <label
                htmlFor="recipients"
                className="block text-md font-semibold text-gray-800"
            >
                Zamestnanec
            </label>
            <MultiSelect required value={formik.values.recipients} onChange={(e) => formik.setFieldValue("recipients",e.value)} 
                options={recipients.map((user) => 
                    ({name:user?.employee?.name || user?.username,id:user.id,searchLabel: removeDiacritics(user?.employee?.name || user?.username).toLowerCase()})
                )} 
                optionLabel="name"
                filter
                filterBy="searchLabel"
                filterMatchMode="contains"
                filterPlaceholder={t('Common.SearchShort')} placeholder={t('Common.SelectEmployees')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
        </div>

         <div className="mb-4">
            <label className="block mb-2 font-semibold">Intenzita</label>
            <select
                name="intensity"
                value={formik.values.sending_data?.intensity ?? ''}
                onChange={(e) => updateSendingData({ intensity: e.target.value,times: [],time: '',daysOfWeek: [],daysOfMonth: [],specialMonthlyDays:[],month: '',timesDaily: [],workdaysOnly: false,weekendHandling: 'before',
                dayMonth:'',notification_before:[] })}
                className="block w-full px-2 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
                <option value="">{t('Ui.R67.Vyberte_intenzitu')}</option>
                <option value="denne">Denne</option>
                <option value="viackrat_den">{t('Common.MultipleDaily')}</option>
                <option value="tyzdenne">{t('Common.Weekly')}</option>
                <option value="mesacne">{t('Common.Monthly')}</option>
                <option value="rocne">{t('Common.Yearly')}</option>
                <option value="nahodne">{t('ChecklistTemplate.Intensity.nahodne')}</option>
            </select>
            {formik.errors['sending_data.intensity'] ? <div className="text-red-600 text-sm mt-1">{formik.errors['sending_data.intensity']}</div> : null}
         </div>

         {/* Viackrát denne má špecifické časy */}
    {formik.values.sending_data?.intensity === 'viackrat_den' && (
    <div className="mb-4">
        <label className="block mb-1 font-medium">{t('Ui.R67.Casy_pocas_dna')}</label>

        {formik.values.sending_data.times && formik.values.sending_data.times.length > 0 ? (
        formik.values.sending_data.times.map((time, index) => (
            <div key={index} className="relative mb-2 flex items-center gap-2">
            <input
                type="time" required
                value={time}
                onChange={(e) => {
                const updated = [...formik.values.sending_data.times];
                updated[index] = e.target.value;
                updateSendingData({ times: updated });
                }}
                className="border rounded-md px-3 py-2 w-full"
            />
            <button
                type="button"
                onClick={() => {
                const updated = [...formik.values.sending_data.times];
                updated.splice(index, 1);
                updateSendingData({ times: updated });
                }}
                title={t('Common.RemoveTime')}
                className="text-red-600 text-xl font-bold hover:text-red-800"
            >
                ×
            </button>
            </div>
        ))
        ) : (
        <p className="text-gray-500 mb-2">{t('Ui.R67.Zatial_nebol_pridany_ziadny_cas')}</p>
    )}

    <button
      type="button"
      onClick={() =>
        updateSendingData({ times: [...(formik.values.sending_data.times || []), ''] })
      }
      className="mt-2 px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
    >
      + Pridať čas
    </button>
  </div>
)}

    {/* Podmienky pre ďalšie polia podľa intenzity */}
    {formik.values.sending_data?.intensity === 'tyzdenne' && (
        <div className="mb-4">
            <label className="block mb-1 font-semibold">{t('Ui.R67.Dni_v_tyzdni')}</label>
            <MultiSelect
            value={formik.values.sending_data.daysOfWeek || []}
            options={daysOfWeekOptions}
            onChange={(e) => updateSendingData({ daysOfWeek: e.value })}
            placeholder={t('Checklist.SelectDays')}
            display="chip"
            className="w-full"
            />
        </div>
    )}

    {formik.values.sending_data?.intensity === 'mesacne' && (
        <div className="mb-4">
            <label className="block mb-1 font-semibold">Dni v mesiaci</label>

            <div className="mb-2">
            <label className="block text-sm mb-1">{t('Ui.R67.Konkretne_dni_v_mesiaci')}</label>
            <MultiSelect
                value={formik.values.sending_data.daysOfMonth || []}
                options={[...Array(31).keys()].map(d => ({
                label: t('Checklist.DayN', { n: d + 1 }),
                value: d + 1,
                }))}
                onChange={(e) => updateSendingData({ daysOfMonth: e.value })}
                placeholder={t('Checklist.SelectDays')}
                display="chip"
                className="w-full"
            />
            </div>

            <div className="mb-2 mt-4">
            <label className="block text-sm mb-1">{t('Ui.R67.Specialne_dni_napr_prvy_pondelok')}</label>
            <MultiSelect
                value={formik.values.sending_data.specialMonthlyDays || []}
                options={specialMonthlyOptions}
                onChange={(e) => updateSendingData({ specialMonthlyDays: e.value })}
                placeholder={t('Checklist.SelectSpecialDays')}
                display="chip"
                className="w-full"
            />
            </div>
        </div>
        )}

    {formik.values.sending_data?.intensity === 'rocne' && (
        <div className="mb-4">
            <label className="block mb-1 font-medium">{t('Ui.R67.Den_a_mesiac')}</label>
            <Calendar required
            value={
                formik.values.sending_data.dayMonth
                ? new Date(`2024-${formik.values.sending_data.dayMonth.month}-${formik.values.sending_data.dayMonth.day}`)
                : null
            }
            onChange={(e) => {
                if (e.value) {
                const date = new Date(e.value);
                updateSendingData({
                    dayMonth: {
                    day: date.getDate(),
                    month: (date.getMonth() + 1).toString().padStart(2, '0'),
                    },
                });
                }
            }}
            dateFormat="dd.mm" // zobrazí len deň a mesiac
            view="month" // zobrazí len mesiace
            showIcon
            showButtonBar
            className="w-full"
            />
        </div>
    )}

    {/* Jeden čas zdieľaný pre intenzity, kde je potrebný */}
    {['denne', 'tyzdenne', 'mesacne', 'rocne','nahodne'].includes(formik.values.sending_data?.intensity) && (
      <div className='mb-2'>
        <label className="block text-md font-semibold text-gray-800 mb-2">Čas {formik.values.sending_data?.intensity == 'nahodne' ? ' do' : ''}</label>
        <input
          type="time" required
          value={formik.values.sending_data?.time ?? ''}
          onChange={(e) => updateSendingData({ time: e.target.value })}
          className="w-full px-2 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
        />
      </div>
    )}

    {/* Termín po NOK */}
    <label className="block text-md font-semibold text-gray-800">{t('Ui.R67.Notifikacia_pouzivatela')}</label>
    <MultiSelect required value={formik.values?.sending_data?.notification_before} onChange={(e) => formik.setFieldValue("sending_data.notification_before",e.value)} options={notifBeforeOptions} optionLabel="label"
    filter placeholder={t('Common.SelectOption')} className="w-full px-4 mt-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>

    {['mesacne', 'rocne'].includes(formik.values.sending_data?.intensity) && <div className="mb-2 mt-2">
        <div className="flex items-center gap-2">
            <Checkbox
            inputId="workdaysOnly"
            checked={formik.values.sending_data.workdaysOnly || false}
            onChange={(e) =>
                updateSendingData({ workdaysOnly: e.checked })
            }
            />
            <label htmlFor="workdaysOnly" className="font-medium">{t('Ui.R67.Len_v_pracovne_dni_Po_Pi')}</label>
        </div>

        {formik.values.sending_data.workdaysOnly && (
            <div className="mt-3">
            <label className="block mb-1 font-medium">{t('Ui.R67.Ak_datum_vychadza_na_vikend')}</label>
            <select required
                value={formik.values.sending_data.weekendHandling || ''}
                onChange={(e) =>
                updateSendingData({ weekendHandling: e.target.value })
                }
                className="w-full border px-3 py-2 rounded-md"
            >
                <option value="">{t('Util.Favorite.SelectPlaceholder')}</option>
                <option value="before">{t('Ui.R67.Presunut_na_predchadzajuci_pracovny_den')}</option>
                <option value="after">{t('Ui.R67.Presunut_na_nasledujuci_pracovny_den')}</option>
            </select>
            </div>
        )}
    </div>}

        {/* Otázky */}
        <div className="mt-6 mb-2 p-4 border rounded-lg shadow-sm bg-gray-50">
            <h3 className="text-lg font-semibold mb-1">{t('Ui.R67.Otazky_a_ulohy')}</h3>
            <div className="mb-2">
                {formik.values.questions.map((q, index) => (
                <div
                    key={index}
                    className="mb-4 border p-3 rounded-md bg-white shadow-sm relative"
                >
                    {/* Textarea pre otázku */}
                    <InputTextarea
                        autoResize
                        placeholder={t('Checklist.QuestionNum', { n: index + 1 })}
                        value={q.question}
                        onChange={(e) => handleQuestionChange(index, 'question', e.target.value)}
                        className="w-11/12 px-4 py-2 border rounded-md"
                    />

                    {/* Presun hore/dole */}
                    <div className="absolute top-2 right-10 flex flex-col space-y-1">
                    <button
                        type="button"
                        onClick={() => moveQuestion(index, 'up')}
                        disabled={index === 0}
                        title={t('Common.MoveUp')}
                        className="text-gray-500 hover:text-gray-700 disabled:text-gray-300"
                    >
                        <i className="pi pi-arrow-up" />
                    </button>
                    <button
                        type="button"
                        onClick={() => moveQuestion(index, 'down')}
                        disabled={index === formik.values.questions.length - 1}
                        title={t('Common.MoveDown')}
                        className="text-gray-500 hover:text-gray-700 disabled:text-gray-300"
                    >
                        <i className="pi pi-arrow-down" />
                    </button>
                    </div>

                    {/* Vymazanie otázky */}
                    <button
                    type="button"
                    onClick={() => removeQuestion(index)}
                    className="absolute top-2 right-2 text-red-600 hover:text-red-800 text-3xl font-bold select-none"
                    title={t('Checklist.DeleteQuestion')}
                    style={{ lineHeight: 1 }}
                    >
                    <i className="pi pi-times" />
                    </button>

                    {/* Grid s možnosťami */}
                    <div className="mt-4 grid grid-cols-1 md:grid-cols-4 gap-4">
                    {/* OK/NOK + poznámka */}
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                        <Checkbox
                            inputId={`okNok-${index}`}
                            checked={q.options.okNok}
                            onChange={(e) =>
                            handleQuestionChange(index, 'okNok', e.checked)
                            }
                        />
                        <label htmlFor={`okNok-${index}`}>OK/NOK</label>
                        </div>
                        {q.options.okNok && (
                        <div className="flex items-center gap-2">
                            <Checkbox
                            inputId={`okNote-${index}`}
                            checked={q.options.okNote}
                            onChange={(e) =>
                                handleQuestionChange(index, 'okNote', e.checked)
                            }
                            />
                            <label htmlFor={`okNote-${index}`}>{t('Ui.R67.OK_poznamka')}</label>
                        </div>
                        )}
                        {q.options.okNok && (
                        <div className="flex items-center gap-2">
                            <Checkbox
                            inputId={`nokNote-${index}`}
                            checked={q.options.nokNote}
                            onChange={(e) =>
                                handleQuestionChange(index, 'nokNote', e.checked)
                            }
                            />
                            <label htmlFor={`nokNote-${index}`}>{t('Ui.R67.NOK_poznamka')}</label>
                        </div>
                        )}
                    </div>

                    {/* FOTO + NOK poznámka */}
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                        <Checkbox
                            inputId={`photo-${index}`}
                            checked={q.options.photo}
                            onChange={(e) =>
                            handleQuestionChange(index, 'photo', e.checked)
                            }
                        />
                        <label htmlFor={`photo-${index}`}>{t('Ui.R67.Povinne_FOTO')}</label>
                        </div>
                        <div className="flex items-center gap-2">
                        <Checkbox
                            inputId={`optional-photo-${index}`}
                            checked={q.options.optional_photo}
                            onChange={(e) =>
                            handleQuestionChange(index, 'optional_photo', e.checked)
                            }
                        />
                        <label htmlFor={`optional-photo-${index}`}>{t('Ui.R67.Volitelne_FOTO')}</label>
                        </div>
                    </div>

                    {/* NO + NO poznámka */}
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                        <Checkbox
                            inputId={`no-${index}`}
                            checked={q.options.no}
                            onChange={(e) =>
                            handleQuestionChange(index, 'no', e.checked)
                            }
                        />
                        <label htmlFor={`no-${index}`}>NO</label>
                        </div>
                        {q.options.no && (
                        <div className="flex items-center gap-2">
                            <Checkbox
                            inputId={`noNote-${index}`}
                            checked={q.options.noNote}
                            onChange={(e) =>
                                handleQuestionChange(index, 'noNote', e.checked)
                            }
                            />
                            <label htmlFor={`noNote-${index}`}>{t('Ui.R67.NO_poznamka')}</label>
                        </div>
                        )}
                    </div>

                    {/* Meno + oddelenia */}
                    <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                        <Checkbox
                            inputId={`name-${index}`}
                            checked={q.options.name}
                            onChange={(e) =>
                            handleQuestionChange(index, 'name', e.checked)
                            }
                        />
                        <label htmlFor={`name-${index}`}>Meno</label>
                        </div>
                        {q.options.name && (
                        <MultiSelect
                            inputId={`priorityDepartments-${index}`}
                            value={q.options.priorityDepartments || []}
                            options={state?.departments}
                            optionLabel="name"
                            optionValue="id"
                            onChange={(e) =>
                            handleQuestionChange(index, 'priorityDepartments', e.value)
                            }
                            display="chip"
                            placeholder={t('Common.SelectDepartments')}
                            className="w-full"
                        />
                        )}
                    </div>
                    </div>
                </div>
                ))}

                <button
                type="button"
                onClick={addQuestion}
                className="mt-1 px-4 py-2 bg-green-600 text-white rounded hover:bg-green-700"
                >{t('Ui.R67.Pridat_otazku')}</button>
            </div>
            </div>


        <div className="mt-3 mb-2 p-4 border rounded-lg shadow-sm bg-gray-50">
            <h3 className="text-lg font-semibold mb-4">{t('Checklist.ResponsibleManager')}</h3>

            {/* Kto */}
            <div className="mb-4">
                <label className="block mb-1 font-medium">Kto</label>
                <Dropdown
                value={formik.values.manager_id || null} onChange={(e) => formik.setFieldValue('manager_id',e.target.value)}
                options={state.users?.map((user) => 
                    ({name:user?.employee?.name || user?.username,id:user.id,searchLabel: removeDiacritics(user?.employee?.name || user?.username).toLowerCase()})
                )} 
                optionLabel="name"
                filter
                filterBy="searchLabel"
                filterMatchMode="contains"
                filterPlaceholder={t('Common.SearchShort')} placeholder={t('Common.SelectUser')} className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
                />
            </div>

            {/* Do koľkých dní sa má vyjadriť */}
            <div>
                <label className="block mb-1 font-medium">{t('Ui.R67.Vyjadrit_sa_do_dni')}</label>
                <input
                type="number"
                name="manager_due_days"
                required
                min="1"
                max="3650"
                step="1"
                value={formik.values?.manager_due_days ?? ''}
                onChange={(e) => formik.setFieldValue('manager_due_days',e.target.value)}
                className="w-full border px-2 py-2 rounded-md"
                placeholder={t('Checklist.EnterDaysCount')}
                />
                {formik.errors.manager_due_days ? <div className="text-red-600 text-sm mt-1">{formik.errors.manager_due_days}</div> : null}
            </div>
        </div>
        <div className='mb-2'>
            <label className='font-semibold  text-sm'>Stroj:</label>
            <Dropdown value={formik.values.machine_id} onChange={(e) => formik.setFieldValue("machine_id",e.value)} 
            options={state.machines.map((machine) => 
                ({name:machine?.name,id:machine.id,searchLabel: removeDiacritics(machine?.name).toLowerCase()})
            )} 
            optionLabel="name"
            filter showClear
            filterBy="searchLabel"
            filterMatchMode="contains"
            filterPlaceholder={t('Common.SearchShort')} placeholder={t('Checklist.SelectMachine')} className="w-full px-4 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"/>
        </div>
        <div>
            <label
                htmlFor="description"
                className="block text-md font-semibold text-gray-800"
            >{t('Common.Note')}</label>
            <textarea
                name="description" type="text" onChange={formik.handleChange} value={formik.values.description ?? ''}
               className="w-full px-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            />
        </div>
        <div className="mb-4">
            <label className="block mb-2 font-semibold">{t('Ui.R67.Stav_aktivity')}</label>
            <select
                name="is_active" required
                value={formik.values.is_active ?? ''}
                onChange={(e) => formik.setFieldValue('is_active',e.target.value)}
                className="block w-full px-2 py-2 text-grey-700 bg-white border rounded-md focus:border-gray-400 focus:ring-gray-300 focus:outline-none focus:ring focus:ring-opacity-40"
            >
                <option value="1">{t('Common.Active')}</option>
                <option value="0">{t('Common.Inactive')}</option>
            </select>
            {formik.errors.is_active ? <div className="text-red-600 text-sm mt-1">{formik.errors.is_active}</div> : null}
         </div>
        <button type="submit" ref={submitRef} className='hidden'></button>  
      </div>
    </form>  
    </div>
    </div>
    </div>
    </>
    );
}